import { ConnectedPaymentsReport } from 'widgets/report/payments';

export function PaymentsReportPage() {
  return <ConnectedPaymentsReport />;
}
